import React from 'react'

import styled from 'styled'
import PageIcon from 'assets/page-icon.jpg'
import { Apps, PermContactCalendar, InfoOutline, Work } from 'icons'
import HeaderBar from './HeaderBar'
import HeaderContainer from './HeaderContainer'

const Logo = () => (
  <styled.Logo
    media-large-inline
    horizontal
    style={{
      fontWeight: 300,
      textTransform: 'none',
      fontSize: '24px',
      letterSpacing: '-0.5px',
      display: 'flex'
    }}
  >
    <div>Przemysław Zalewski</div>
  </styled.Logo>
)

const LargeIcon = (
  <styled.Icon media-large style={{ paddingRight: 12 }}>
    <styled.PageIcon
      tag="img"
      src={PageIcon}
      alt="Ciunkos.com"
      style={{ width: 40, height: 40, borderRadius: '50%' }}
    />
  </styled.Icon>
)

const routes = [
  {
    name: <Logo />,
    longName: 'Blog',
    title: 'Blog',
    href: '/',
    largeIcon: LargeIcon,
    style: {
      paddingLeft: 16,
      paddingRight: 16,
      justifySelf: 'flex-start',
      alignItems: 'flex-start',
      flexGrow: 1,
      flexShrink: 0,
      minWidth: 170
    },
    classes: {
      navbaritem: false,
      headeritem: true
    }
  },
  {
    name: 'Services',
    href: 'https://ciunkos.com/hire-me#services',
    style: {
      justifySelf: 'flex-end',
      flexGrow: 0,
      flexShrink: 1,
      flexBasis: '160px'
    },
    classes: {
      navbaritem: true,
      headeritem: true,
      'nav-services': true
    },
    icon: <Work />
  },
  {
    name: 'Apps',
    href: '/apps',
    style: {
      justifySelf: 'flex-end',
      flexGrow: 0,
      flexShrink: 1,
      flexBasis: '160px'
    },
    classes: {
      navbaritem: true,
      headeritem: true
    },
    icon: <Apps />
  },
  {
    name: 'Resume',
    href: '/resume',
    style: {
      justifySelf: 'flex-end',
      flexGrow: 0,
      flexShrink: 1,
      flexBasis: '160px'
    },
    classes: {
      navbaritem: true,
      headeritem: true
    },
    icon: <PermContactCalendar />
  },
  {
    name: 'About',
    href: '/about',
    style: {
      justifySelf: 'flex-end',
      flexGrow: 0,
      flexShrink: 1,
      flexBasis: '160px'
    },
    classes: {
      navbaritem: true,
      headeritem: true
    },
    icon: <InfoOutline />
  },
  {
    name: 'Hire me',
    href: 'https://ciunkos.com/hire-me',
    style: {
      justifySelf: 'flex-end',
      flexGrow: 0,
      flexShrink: 0,
      marginLeft: 8,
      marginRight: 16
    },
    classes: {
      navbaritem: false,
      headeritem: true,
      'hire-cta': true
    }
  }
]

const Header = ({ subheader, height = 0 }) => (
  <HeaderContainer
    header={top => <HeaderBar routes={routes} scrolled-top={top <= 64} />}
    subheader={subheader}
    height={height}
  />
)

export default Header
